/**
 * LOCATION: dashboard-agent/src/pages/Login.js
 * Premium redesign — unique, mobile responsive, FA icons only
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [agentName,   setAgentName]   = useState('');
  const [businessId,  setBusinessId]  = useState('');
  const [error,       setError]       = useState('');
  const [loading,     setLoading]     = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    if (!agentName.trim())  { setError('Please enter your full name'); return; }
    if (!businessId.trim()) { setError('Please enter the Business ID'); return; }

    setLoading(true);
    setTimeout(() => {
      const agentData = {
        name:       agentName.trim(),
        businessId: businessId.trim(),
        id:         'agent_' + Date.now(),
        loginTime:  new Date().toISOString(),
      };
      localStorage.setItem('janimony_agent', JSON.stringify(agentData));
      window.location.href = '/chats';
    }, 600);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Syne:wght@700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        .agl-page{min-height:100vh;display:flex;font-family:'DM Sans',sans-serif;background:#0c0c14;position:relative;overflow:hidden;}

        /* Animated background grid */
        .agl-grid{position:fixed;inset:0;background-image:linear-gradient(rgba(102,126,234,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(102,126,234,0.05) 1px,transparent 1px);background-size:40px 40px;pointer-events:none;}

        /* Glowing orbs */
        .agl-orb1{position:fixed;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(102,126,234,0.2) 0%,transparent 70%);top:-150px;right:-100px;pointer-events:none;animation:agl-pulse 6s ease-in-out infinite;}
        .agl-orb2{position:fixed;width:350px;height:350px;border-radius:50%;background:radial-gradient(circle,rgba(118,75,162,0.18) 0%,transparent 70%);bottom:-100px;left:-80px;pointer-events:none;animation:agl-pulse 8s ease-in-out infinite reverse;}
        @keyframes agl-pulse{0%,100%{transform:scale(1);opacity:1;}50%{transform:scale(1.08);opacity:0.7;}}

        /* Left panel */
        .agl-left{width:420px;flex-shrink:0;display:flex;flex-direction:column;justify-content:center;padding:60px 48px;position:relative;z-index:1;border-right:1px solid rgba(255,255,255,0.05);}
        .agl-brand{display:flex;align-items:center;gap:12px;margin-bottom:56px;}
        .agl-brand-icon{width:42px;height:42px;display:flex;align-items:center;justify-content:center;}
        .agl-brand-name{font-family:'Syne',sans-serif;font-size:20px;font-weight:800;color:#fff;}
        .agl-badge{display:inline-flex;align-items:center;gap:6px;padding:5px 12px;background:rgba(102,126,234,0.12);border:1px solid rgba(102,126,234,0.25);border-radius:20px;font-size:11px;font-weight:700;color:#a5b4fc;letter-spacing:0.8px;margin-bottom:24px;}
        .agl-headline{font-family:'Syne',sans-serif;font-size:38px;font-weight:800;color:#fff;line-height:1.15;margin-bottom:16px;}
        .agl-headline span{background:linear-gradient(135deg,#667eea,#a78bfa);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
        .agl-desc{font-size:15px;color:rgba(255,255,255,0.45);line-height:1.7;margin-bottom:44px;}
        .agl-stats{display:grid;grid-template-columns:1fr 1fr;gap:14px;}
        .agl-stat{padding:16px 18px;background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.07);border-radius:14px;}
        .agl-stat-val{font-size:26px;font-weight:800;color:#fff;margin-bottom:4px;}
        .agl-stat-lbl{font-size:12px;color:rgba(255,255,255,0.35);font-weight:600;}

        /* Right panel */
        .agl-right{flex:1;display:flex;align-items:center;justify-content:center;padding:40px;position:relative;z-index:1;}
        .agl-card{width:100%;max-width:420px;background:rgba(255,255,255,0.04);backdrop-filter:blur(24px);border:1px solid rgba(255,255,255,0.1);border-radius:24px;padding:44px 40px;box-shadow:0 40px 80px rgba(0,0,0,0.5),inset 0 1px 0 rgba(255,255,255,0.08);}
        .agl-card-icon{width:52px;height:52px;border-radius:16px;background:linear-gradient(135deg,rgba(102,126,234,0.3),rgba(118,75,162,0.3));border:1px solid rgba(102,126,234,0.3);display:flex;align-items:center;justify-content:center;margin-bottom:20px;}
        .agl-card-title{font-family:'Syne',sans-serif;font-size:24px;font-weight:800;color:#fff;margin-bottom:6px;}
        .agl-card-sub{font-size:13px;color:rgba(255,255,255,0.4);margin-bottom:30px;line-height:1.6;}
        .agl-err{background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);color:#fca5a5;padding:11px 14px;border-radius:10px;font-size:13px;margin-bottom:18px;display:flex;align-items:center;gap:8px;}
        .agl-grp{margin-bottom:18px;}
        .agl-lbl{display:block;font-size:11px;font-weight:700;color:rgba(255,255,255,0.4);margin-bottom:8px;letter-spacing:0.6px;text-transform:uppercase;}
        .agl-wrap{position:relative;}
        .agl-inp{width:100%;padding:13px 14px 13px 42px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);border-radius:12px;color:#fff;font-size:14px;outline:none;font-family:'DM Sans',sans-serif;transition:all 0.2s;box-sizing:border-box;}
        .agl-inp::placeholder{color:rgba(255,255,255,0.2);}
        .agl-inp:focus{border-color:rgba(102,126,234,0.6);background:rgba(102,126,234,0.08);box-shadow:0 0 0 3px rgba(102,126,234,0.12);}
        .agl-ico{position:absolute;left:14px;top:50%;transform:translateY(-50%);color:rgba(255,255,255,0.3);font-size:14px;}
        .agl-hint{font-size:11px;color:rgba(255,255,255,0.25);margin-top:5px;line-height:1.5;}
        .agl-btn{width:100%;padding:14px;background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:'DM Sans',sans-serif;display:flex;align-items:center;justify-content:center;gap:8px;box-shadow:0 8px 20px rgba(102,126,234,0.4);transition:all 0.2s;margin-top:6px;}
        .agl-btn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 12px 28px rgba(102,126,234,0.5);}
        .agl-btn:disabled{opacity:0.6;cursor:not-allowed;}
        .agl-footer{text-align:center;margin-top:22px;font-size:12px;color:rgba(255,255,255,0.2);}

        /* Mobile */
        @media(max-width:860px){
          .agl-page{flex-direction:column;}
          .agl-left{width:100%;padding:36px 28px;border-right:none;border-bottom:1px solid rgba(255,255,255,0.06);}
          .agl-headline{font-size:28px;}
          .agl-stats{display:none;}
          .agl-right{padding:28px 20px;}
          .agl-card{padding:32px 24px;}
        }
        @media(max-width:480px){
          .agl-left{padding:28px 18px;}
          .agl-headline{font-size:24px;}
          .agl-right{padding:20px 14px;}
          .agl-card{padding:26px 18px;border-radius:18px;}
        }
      `}</style>

      <div className="agl-page">
        <div className="agl-grid" />
        <div className="agl-orb1" />
        <div className="agl-orb2" />

        {/* Left panel */}
        <div className="agl-left">
          <div className="agl-brand">
  <div className="agl-brand-icon" style={{ background: 'transparent', boxShadow: 'none' }}>
  <img 
    src={`${process.env.PUBLIC_URL}/janimony-logo.png`} 
    alt="Janimony" 
    style={{ width: '100px', height: 'auto', objectFit: 'contain' }}
  />
</div>
</div>

          <div className="agl-badge">
            <i className="fa-solid fa-headset" style={{ fontSize: 10 }}></i>
            AGENT PORTAL
          </div>

          <h1 className="agl-headline">
            Support your<br />
            customers <span>in real time</span>
          </h1>

          <p className="agl-desc">
            Log in to start handling live chat sessions, picking up where the AI left off, and keeping customers happy.
          </p>

          <div className="agl-stats">
            {[
              { icon: 'fa-bolt',          color: '#667eea', val: '< 2s',  lbl: 'Avg. response time' },
              { icon: 'fa-face-smile',    color: '#10b981', val: '97%',   lbl: 'Customer satisfaction' },
              { icon: 'fa-comments',      color: '#f59e0b', val: '24/7',  lbl: 'Live support window' },
              { icon: 'fa-language',      color: '#8b5cf6', val: '6+',    lbl: 'Languages supported' },
            ].map(s => (
              <div key={s.lbl} className="agl-stat">
                <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
                  <i className={`fa-solid ${s.icon}`} style={{ color: s.color, fontSize: 13 }}></i>
                </div>
                <div className="agl-stat-val">{s.val}</div>
                <div className="agl-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right panel — form */}
        <div className="agl-right">
          <div className="agl-card">
           <div className="agl-card-icon" style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}>
  <img 
    src={`${process.env.PUBLIC_URL}/janimony-logo.png`} 
    alt="Janimony" 
    style={{ width: '100px', height: 'auto', objectFit: 'contain' }}
  />
</div>
            <h2 className="agl-card-title">Agent Sign In</h2>
            <p className="agl-card-sub">Enter your name and Business ID provided by your employer.</p>

            {error && (
              <div className="agl-err">
                <i className="fa-solid fa-circle-exclamation"></i>
                {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="agl-grp">
                <label className="agl-lbl">Your Full Name</label>
                <div className="agl-wrap">
                  <i className="fa-solid fa-user agl-ico"></i>
                  <input
                    className="agl-inp"
                    type="text"
                    placeholder="e.g. John Doe"
                    value={agentName}
                    onChange={e => { setAgentName(e.target.value); setError(''); }}
                    autoFocus
                    required
                  />
                </div>
              </div>

              <div className="agl-grp">
                <label className="agl-lbl">Business ID</label>
                <div className="agl-wrap">
                  <i className="fa-solid fa-key agl-ico"></i>
                  <input
                    className="agl-inp"
                    type="text"
                    placeholder="e.g. jmc_abc123..."
                    value={businessId}
                    onChange={e => { setBusinessId(e.target.value); setError(''); }}
                    required
                  />
                </div>
                <p className="agl-hint">
                  <i className="fa-solid fa-circle-info" style={{ marginRight: 4 }}></i>
                  Ask your business owner for this ID
                </p>
              </div>

              <button type="submit" className="agl-btn" disabled={loading}>
                {loading
                  ? <><i className="fa-solid fa-spinner fa-spin"></i>Signing in...</>
                  : <><i className="fa-solid fa-right-to-bracket"></i>Start Handling Chats</>}
              </button>
            </form>

            <p className="agl-footer">
              Powered by <strong style={{ color: 'rgba(255,255,255,0.4)' }}>Janimony.chat</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;